import classNames from 'classnames';
import React from 'react';

import { Icon } from './Icon';

export interface InputFeedbackProps {
  text: string | React.ReactNode;
  icon?: string;
  state?: string;
  hide?: boolean;
}

export const InputFeedback: React.FC<InputFeedbackProps> = ({ text, icon, state, hide }) => {
  if (hide) {
    return <></>;
  }
  return (
    <div className={classNames(`oejr-input-feedback`, `oejr-input-feedback-${state}`)}>
      <Icon name={icon} />
      <span className="oejr-input-feedback-text">{text}</span>
    </div>
  );
};
